import React from 'react';

import Thinwallproduct from './Thinwallproduct';
import Foodpackmobi from './Foodpackmobi';
import Disposablecont from './Disposablecont';
import Energysaving from './Energysaving';
import Machinedetails from './Machinedetails';

const Petperforminje = () => {
    return (
        <div>
            <Thinwallproduct />
            < Foodpackmobi />
            <Disposablecont />
            <Energysaving />
            <Machinedetails />
        </div>
    );
};

export default Petperforminje;
